import { Link, NavLink, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RiHome2Fill, RiMenu3Fill, RiCloseFill } from 'react-icons/ri'
import { useEffect, useState } from 'react'
import NavbarMobileMenu from './NavbarMobileMenu'

export default function NavbarMobile() {
  const { lng } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const { t, i18n } = useTranslation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleOnClickChangeLanguage = (newLng) => {
    if (newLng !== lng) {
      const newUrl = location.pathname.replace(`/${lng}`, `/${newLng}`)
      i18n.changeLanguage(newLng)
      navigate(`${newUrl}?${searchParams.toString()}`)
    }
  }

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)

  useEffect(() => {
    setIsMenuOpen(false)
  }, [location.pathname])
  return (
    <nav className="border-muted-300 relative block border-b bg-light py-2 md:hidden">
      <div className="app-container flex items-center justify-between px-8">
        <button
          className="border-muted-300 hover:border-secondary-600 hover:bg-muted-300 border-2 p-1.5 transition-colors"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          {isMenuOpen ? (
            <RiCloseFill size={26} />
          ) : (
            <RiMenu3Fill
              className="ltr:rotate-180"
              size={26}
            />
          )}
        </button>
        <button
          className="hover:border-secondary-600 border-muted-300 hover:bg-muted-300 border-2 px-3 py-1"
          onClick={() => handleOnClickChangeLanguage(lng === 'en' ? 'ar' : 'en')}
        >
          {lng === 'en' ? 'العربية' : 'English'}
        </button>
      </div>

      <div
        className={`absolute left-0 right-0 top-full z-20 grid overflow-hidden bg-white shadow-lg transition-[grid-template-rows] duration-300 ease-in-out ${
          isMenuOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
        aria-hidden={!isMenuOpen}
      >
        <div className="min-h-0">
          <NavbarMobileMenu lng={lng} />
        </div>
      </div>
    </nav>
  )
}
